import { render, staticRenderFns } from "./monthly_attendances.vue?vue&type=template&id=f6df5408&scoped=true"
import script from "./monthly_attendances.vue?vue&type=script&lang=js"
export * from "./monthly_attendances.vue?vue&type=script&lang=js"
import style0 from "./monthly_attendances.vue?vue&type=style&index=0&id=f6df5408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6df5408",
  null
  
)

export default component.exports